import React from 'react';

function GizlilikPage() {
  return (
    <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md max-w-4xl mx-auto prose">
      <h1 className="text-3xl font-bold text-brand-green mb-4">Gizlilik Politikası</h1>
      <p>Minela Kids olarak, kullanıcılarımızın kişisel verilerinin gizliliğine büyük önem veriyoruz. Bu politika, sitemizi ziyaret ettiğinizde topladığımız bilgi türlerini ve bu bilgileri nasıl kullandığımızı açıklamaktadır.</p>
      
      <h2>Toplanan Bilgiler</h2>
      <ul>
        <li>Üyelik ve sipariş sırasında verdiğiniz ad, soyad, e-posta, telefon ve adres bilgileri.</li>
        <li>Sitemizi kullanımınıza ilişkin teknik veriler (IP adresi, tarayıcı türü vb.).</li>
      </ul>

      <h2>Bilgilerin Kullanımı</h2>
      <p>Topladığımız bilgiler, siparişlerinizi işlemek, hesabınızı yönetmek, size daha iyi hizmet sunmak ve yasal yükümlülüklerimizi yerine getirmek amacıyla kullanılır.</p>
    </div>
  );
}

export default GizlilikPage;